import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles/global.css'
import 'animate.css'

import './plugins/vant' // 按需引入Vant组件（见plugins/vant.js）
import './plugins/directives' // 注册自定义指令（见plugins/directives.js）
import vuetimeline from '@growthbunker/vuetimeline'

Vue.config.productionTip = false

Vue.use(vuetimeline)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
